//export const APISERVERURL='http://localhost:6701'
export const APISERVERURL='https://api.backend.gurukulseniorsecondaryschool.com'
